/** 
 * @type {PlansFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    codes: null,
    names: null,
    project_ids: null,
}
/** 
* @returns {PlansFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/PlansFilter.js